import classNames from 'classnames';
import React from 'react';

import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {escapeHtml} from '@udemy/shared-utils';
import {Instructor} from '@udemy/shopping';

import styles from './shopping-item.module.less';

interface InstructorsProps {
    instructors: Instructor[];
}

export const Instructors = ({instructors}: InstructorsProps) => {
    const {gettext, interpolate, ninterpolate} = useI18n();
    const instructorNames = instructors.map((instructor) => instructor.display_name);
    if (instructorNames.length === 0) {
        return null;
    }

    let template;
    const components = {instructor: <></>};
    const firstInstructor = escapeHtml(instructorNames[0]);
    if (instructorNames.length === 1) {
        template = interpolate(
            gettext('By <span class="instructor">%(title)s</span>'),
            {title: firstInstructor},
            true,
        );
    } else {
        const count = instructorNames.length - 1;
        template = ninterpolate(
            'By <span class="instructor">%(title)s</span> and %(count)s other',
            'By <span class="instructor">%(title)s</span> and %(count)s others',
            count,
            {title: firstInstructor, count},
        );
    }

    return !instructors.length ? null : (
        <div className={classNames('ud-text-xs', styles.instructors)}>
            <span className="ud-sr-only">
                {ngettext('Instructor:', 'Instructors:', instructors.length)}
            </span>
            <LocalizedHtml
                html={template}
                interpolate={components}
                className={styles['instructor-list']}
            />
        </div>
    );
};
